import { isEmpty } from 'lodash'

export const CollectiveUtil = {
  /**
   * @param {Basket | BasketPayload} basket
   * @returns {boolean}
   */
  isCollective(basket) {
    return !isEmpty(basket.collective)
  },

  /**
   * @param {ConditionFile} condition
   * @param {ConditionProduct[]} products
   * @returns {boolean}
   */
  filterFileByProducts(condition, products) {
    const includesCategory = product => condition.categories?.includes(product.category)
    const includesGroup = product => condition.groups?.includes(product.group)
    const includesProduct = product => condition.products?.includes(product.product)
    const excludesProduct = product => condition.excludes?.includes(product.product)
    const hasNoCollective = product => !(condition.collective && product.collective)

    return products.some(product => {
      if (
        (!includesCategory(product) && !includesGroup(product) && !includesProduct(product)) ||
        excludesProduct(product)
      ) {
        return false
      }
      if (hasNoCollective(product)) return true

      const { collective } = product
      const { groups, contracts } = condition.collective

      const includesContractNumber = contracts?.includes(collective.contractNumber)
      if (!includesContractNumber) return false

      return groups ? groups?.includes(collective.personGroup) : true
    })
  }
}
